/*==================================================
  HERSHOP HERO
  PART 1 / 5
==================================================*/

(() => {

'use strict';

/*==================================================
CACHE
==================================================*/

const hero = document.querySelector('.hs-hero');

if(!hero) return;

const video = hero.querySelector('.hs-hero__video');

const eyebrow = hero.querySelector('.hs-hero__eyebrow');

const title = hero.querySelector('.hs-hero__title');

const subtitle = hero.querySelector('.hs-hero__subtitle');

const button = hero.querySelector('.hs-hero__button');

const scrollIndicator = hero.querySelector('.hs-scroll');

/*==================================================
PART 2
==================================================*/

/*==================================================
SCROLL ENGINE
==================================================*/

const scroll={

    target:0,

    current:0,

    ease:.10

};

function clamp(value,min,max){

    return Math.max(min,Math.min(max,value));

}

function range(start,end,value){

    return clamp(

        (value-start)/(end-start),

        0,

        1

    );

}

/* cache the hero's document offset once, and only
   recompute it on resize -- avoids a layout-forcing
   getBoundingClientRect() call on every single frame */

let heroTop=0;

function cacheHeroTop(){

    heroTop=hero.getBoundingClientRect().top+window.scrollY;

}

cacheHeroTop();

function updateScroll(){

    scroll.target=Math.max(window.scrollY-heroTop,0);

    scroll.current+=

    (scroll.target-scroll.current)

    *scroll.ease;

    /* snap when close enough so the loop stops doing
       useless micro-updates once it has converged */
    if(Math.abs(scroll.target-scroll.current)<0.05){

        scroll.current=scroll.target;

    }

}

/*==================================================
TIMELINE
==================================================*/

function updateTimeline(){

    hero.style.setProperty(

        '--eyebrow-progress',

        range(0,40,scroll.current)

    );

    hero.style.setProperty(

        '--title-progress',

        range(40,90,scroll.current)

    );

    hero.style.setProperty(

        '--subtitle-progress',

        range(90,150,scroll.current)

    );

    hero.style.setProperty(

        '--button-progress',

        range(150,220,scroll.current)

    );

    hero.style.setProperty(

        '--scroll-hint-progress',

        range(0,80,scroll.current)

    );

}

/*==================================================
PART 3
MAIN ENGINE
==================================================*/

let rafId = null;

let lastScroll=-1;

function engine(){

    updateScroll();

    if(scroll.current!==lastScroll){

        updateTimeline();

        lastScroll=scroll.current;

    }

    rafId=requestAnimationFrame(engine);

}

/*==================================================
START
==================================================*/

function startEngine(){

    if(rafId) return;

    rafId=requestAnimationFrame(engine);

}

/*==================================================
STOP
==================================================*/

function stopEngine(){

    cancelAnimationFrame(rafId);

    rafId=null;

}

/*==================================================
RESIZE
==================================================*/

window.addEventListener('resize',()=>{

    cacheHeroTop();

    updateScroll();

});

/*==================================================
START
==================================================*/

startEngine();

/*==================================================
PART 4
==================================================*/

/*==================================================
VIDEO OBSERVER
==================================================*/

let heroVisible = true;

if(video){

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry)=>{

            heroVisible = entry.isIntersecting;

            if(heroVisible){

                video.play().catch(()=>{});

                startEngine();

            }else{

                video.pause();

                stopEngine();

            }

        });

    },{

        threshold:.15

    });

    observer.observe(hero);

}

/*==================================================
PAGE VISIBILITY
==================================================*/

document.addEventListener("visibilitychange",()=>{

    if(document.hidden){

        stopEngine();

        if(video) video.pause();

        return;

    }

    if(heroVisible){

        if(video){

            video.play().catch(()=>{});

        }

        startEngine();

    }

});

/*==================================================
WINDOW FOCUS
==================================================*/

window.addEventListener("blur",()=>{

    stopEngine();

});

window.addEventListener("focus",()=>{

    if(heroVisible){

        startEngine();

    }

});

/*==================================================
PART 5
==================================================*/

/*==================================================
HELPERS
==================================================*/

hero.__engine = {

    start:startEngine,

    stop:stopEngine,

    hero,

    video,

    scroll

};

/*==================================================
DEBUG
==================================================*/

window.HERSHOP = hero.__engine;

/*==================================================
END
==================================================*/

})();